import { jsxs, jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box/index.js";
import "lottie-react";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "react";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import "@mui/material";
import { de, enIE } from "date-fns/locale";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import { Dialog } from "../../../../../components/dialog/dialog.js";
import "../../../../../components/icons/all/all.js";
import "../../../../../components/label/label.styles.js";
import "../../../../../components/menu-item/menu-item.js";
import "../../../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import "../../../../../components/snackbar/snackbar.styles.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/translations/utils.js";
import "../../../../../components/time-select/time-select.styles.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import { useQueryClient } from "@tanstack/react-query";
import { format } from "date-fns";
import { Language } from "../../appointment-schedule.types.js";
import { useDeleteBlocker } from "../../hooks/useDeleteBlocker.js";
import { useWorkingTimesProvider } from "../../providers/working-times-provider.js";
import { StyledTitleText, StyledBodyText, DurationText } from "./blocker-deletion-modal.styles.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "../../providers/axios-provider.js";
import "axios";
import "../../helpers/getViewTimePeriod.js";
import "../../appointment-schedule.constants.js";
import "../../helpers/getEmptyCalendarSlots.js";
import "../../helpers/groupBy.js";
import "../../../../../utils/time/time.js";
import "lodash";
import "../../helpers/common.js";
import "fast-memoize";
import "../../helpers/fillEmptyDays.js";
import "../../hooks/useWorkingTimes.js";
const BlockerDeletionModal = ({
  blocker,
  onCancel,
  onSave,
  labels,
  language = Language.DEUTSCH
}) => {
  const queryClient = useQueryClient();
  const { queryKey: workingTimesQueryKey } = useWorkingTimesProvider();
  const { mutateAsync: deleteBlocker } = useDeleteBlocker(async () => {
    if (workingTimesQueryKey) {
      await queryClient.invalidateQueries({ queryKey: workingTimesQueryKey });
    }
    onSave();
  });
  const getFormattedBlockerDuration = () => {
    const formattedDate = format(new Date(blocker.startDate), "d MMMM yyyy", {
      locale: language === Language.DEUTSCH ? de : enIE
    });
    return `${formattedDate} ${labels.dates.from} ${blocker.startTime} ${labels.dates.to} ${blocker.endTime}`;
  };
  const handleClick = (event) => {
    event.stopPropagation();
  };
  const handleDeleteBlocker = async () => {
    await deleteBlocker(blocker.referenceId ?? "");
  };
  return /* @__PURE__ */ jsxs(
    Dialog,
    {
      open: true,
      onClose: onCancel,
      onCancel,
      onClick: handleClick,
      onSave: handleDeleteBlocker,
      labels: labels.buttons,
      width: 440,
      children: [
        /* @__PURE__ */ jsx(Box, { mt: 2, mb: 2, children: /* @__PURE__ */ jsx(StyledTitleText, { variant: "Lato H5", children: labels.title }) }),
        /* @__PURE__ */ jsxs(Box, { mt: 2, children: [
          /* @__PURE__ */ jsxs(StyledBodyText, { variant: "Lato Body 2", children: [
            labels.message,
            /* @__PURE__ */ jsx(DurationText, { children: getFormattedBlockerDuration() }),
            " ",
            language === Language.DEUTSCH && labels.messageSuffix
          ] }),
          /* @__PURE__ */ jsx(StyledBodyText, { mt: 2, variant: "Lato Body 2", children: labels.confirmation })
        ] })
      ]
    }
  );
};
BlockerDeletionModal.displayName = "BlockerDeletionModal";
export {
  BlockerDeletionModal as default
};
